module.exports = __webpack_public_path__ + "img/map-icon.6ef36186.svg";